import { OrejasUser, Role } from "@/store/users";
import { authClient } from "./client";
import * as firebase from "firebase/app";
import "firebase/auth";
import { FromError, AuthError, UserError } from "./error";
import ky from "ky";
import store from "@/store";
import { AuthState, LoggedUser } from "@/store/auth";

export async function startLogin(type: AuthTypes) {
  let provider: firebase.auth.AuthProvider;
  if (type === "google") {
    provider = new firebase.auth.GoogleAuthProvider();
  } else if (type === "microsoft") {
    provider = new firebase.auth.OAuthProvider("microsoft.com");
  } else {
    return;
  }

  try {
    await firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION);
    await firebase.auth().signInWithRedirect(provider);
  } catch (err) {
    throw AuthError(err);
  }
}

export function recoverAuth(): Promise<LoggedUser | undefined> {
  let unsub: firebase.Unsubscribe;
  return new Promise<LoggedUser | undefined>((resolve) => {
    unsub = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        handleUser(user)
          .then((user) => {
            resolve(user);
          })
          .catch(() => {
            resolve(undefined);
          });
      } else {
        resolve(undefined);
      }
    });
  }).finally(() => {
    if (unsub) {
      unsub();
    }
  });
}

export async function handleUser(
  userFirebase: firebase.User | null
): Promise<LoggedUser> {
  if (!userFirebase) {
    throw new UserError("usuario desconocido");
  }
  const token = await userFirebase.getIdToken();
  const user = await getUserRole(token);
  if (!user || !user.customerCurrent) {
    throw new UserError("Usuario sin permisos");
  }
  return {
    user: user,
    firebaseUser: userFirebase,
  };
}

async function getUserRole(token: string): Promise<OrejasUser> {
  const client = authClient(token);
  try {
    const auser = await getLoggedUser(client);
    return auser;
  } catch (err) {
    throw await FromError(err);
  }
}

export async function getLoggedUser(client: typeof ky): Promise<OrejasUser> {
  const authstore = ((store.state as unknown) as any).auth as AuthState;
  if (authstore.currentUser.user?.id) {
    return authstore.currentUser.user;
  }
  const user = await client.get("users/me").json<OrejasUser>();
  if (user.customers.length > 0) {
    user.customerCurrent = user.customers[0];
  }
  return user;
}

export type AuthTypes = "google" | "microsoft" | "email";
export type AuthUser = {
  userFirebase: firebase.User;
  user: OrejasUser;
};
